module.exports = __webpack_public_path__ + "img/shutterstock_590870102-16x9ratio.f1351d51.jpg";